module.exports = __webpack_public_path__ + "media/images/pic/courses/4-0e9a1b0c700c90318146b1f2b7eb0523.jpeg";